module.exports = __webpack_public_path__ + "assets/b47a2651c3898d81593d5c9f1c23d31d.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/buttons/coins/Bet_2.mp3
 ** module id = 331
 ** module chunks = 0
 **/